import * as React from 'react';

type ExerciseRequirements =
  "rugbyPlayersWarmup" |
  "handlingDrills" |
  "tacklingDrills" |
  "kickingDrills" |
  "readingPlayDrills";

interface FormattedRequirementProps {
  exercise: ExerciseRequirements;
}

const requirements = {
  rugbyPlayersWarmup: {
    equipmentRequired: 'TRS, Football.',
    participantNumber: 'Two or more.',
    suitability: 'All standards.',
    areaRequired: 'Three metres wide to allow for the screen and five metres either side of the screen.',
    focus: 'To progress through simple passing and catching functions in preparation for more complex drills.',
    skillsInvolved: 'Focus, balance, anticipation, reflexes, catching the ball, hand eye coordination.',
    setUp: 'Players stand facing each other either side of the TRS. Each player stands approximately four metres from the TRS. With four players, simply rotate positions.'
  },
  handlingDrills: {
    equipmentRequired: 'TRS, Football.',
    participantNumber: 'Four or more.',
    suitability: 'All standards for Drills 1 to 5, however 6 and 7 are suitable for more advanced players.',
    areaRequired: 'Will vary, but a minimum of 10m x 10m grid.',
    focus: 'To improve passing, catching and evasion by using the TRS. (i.e. ball hidden from support player until ball comes through screen and the receiver benefits by having to react faster and improve response times.)',
    skillsInvolved: '',
    setUp: ''
  },
  tacklingDrills: {
    equipmentRequired: 'TRS, Football.',
    participantNumber: 'Five or more.',
    suitability: 'Club player plus.',
    areaRequired: 'Will vary, but a minimum of 15m x 15m.',
    focus: 'To improve reaction and response times and communication as defenders remain unseen until coming through TRS, requiring player callouts. Attackers must react faster and play what is in front of them.',
    skillsInvolved: '',
    setUp: ''
  },
  kickingDrills: {
    equipmentRequired: 'TRS, Football.',
    participantNumber: 'Two or more.',
    suitability: 'All standards.',
    areaRequired: 'Will vary, but a minimum of 10m x 10m.',
    focus: 'To improve anticipation and co-ordination using TRS features, e.g. the kicker remains unseen until ball passes through screen. The receiver benefits from the late visibility of the ball causing faster reaction.',
    skillsInvolved: '',
    setUp: ''
  },
  readingPlayDrills: {
    equipmentRequired: 'General support and defence.',
    participantNumber: 'Five plus.',
    suitability: 'All standards.',
    areaRequired: 'Will vary, but a minimum of 15 metres by 12 metres.',
    focus: 'To improve players reaction times to a changing game situation for defenders and to have supporting attacking players react and run into created holes.',
    skillsInvolved: '',
    setUp: 'Passive defenders are 6 to 7 metres from the TRS and are 2 metres apart.'
  }
};

const FormattedRequirement = ({ exercise }: FormattedRequirementProps) => {
  let req = requirements[exercise];

  let SkillsInvolved = () => (
    <>
      <strong>Skills Involved:</strong> {req.skillsInvolved}<br />
    </>
  );

  let Setup = () => (
    <>
      <strong>Set Up:</strong> {req.setUp}
    </>
  );

  return (
    <p>
      <strong>Equipment required:</strong> {req.equipmentRequired}<br />
      <strong>Number of Participants:</strong> {req.participantNumber}<br />
      <strong>Standard suitability:</strong> {req.suitability}<br />
      <strong>Area Required:</strong> {req.areaRequired}<br />
      <strong>Focus:</strong> {req.focus}<br />
      { req.skillsInvolved && <SkillsInvolved /> }
      { req.setUp && <Setup /> }
    </p>
  )
};

export {
  FormattedRequirement,
};
